<template>
  <a-modal
    :title="title"
    :visible="visible"
    @cancel="handleCancel"
    @ok="handleCancel"
    @close="handleCancel"
    width="1200px">
    <a-table
             :scroll="{ x: '130%' }"
             bordered
             :columns="addressColumns"
             :data-source="addressLogList"
             :pagination="false"
             :loading="loading">
      <span slot="beforeDetailedAddress" slot-scope="text, record">{{record.beforeAddress.areap}}{{record.beforeAddress.areac}}{{record.beforeAddress.areax}}{{record.beforeAddress.detailedAddress}}</span>
      <span slot="afterDetailedAddress" slot-scope="text, record">{{record.afterAddress.areap}}{{record.afterAddress.areac}}{{record.afterAddress.areax}}{{record.afterAddress.detailedAddress}}</span>
    </a-table>
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      show-quick-jumper
      :pageSizeOptions="pageSizeOptions"
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => getTotal(total)"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
    <div style="height: 25px">

    </div>
    <div class="bottom-control">
      <a-space>
        <a-button type="dashed" @click="handleCancel">
          {{$t('取消')}}
        </a-button>
      </a-space>
    </div>
  </a-modal>
</template>

<script>
import { changeAddress } from '@/api/order/sell'

export default {
  name: 'ChangeLog',
  props: {
  },
  data() {
    return {
      title:undefined,
      loading: false,
      visible: false,
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      total:0,
      queryParam: {
        id: undefined,
        pageNum: 1,
        pageSize: 10
      },
      addressLogList: [],
      raiseLogList: [],
      addressColumns: [
        {
          title: '操作时间',
          dataIndex: 'createTime',
          width: '120px'
        },
        {
          title: '变更前',
          dataIndex: 'beforeAddress',
          children: [
            {
              title: this.$t('收货人姓名'),
              dataIndex: 'beforeAddress.realName'
            },
            {
              title: this.$t('手机号'),
              dataIndex: 'beforeAddress.mobile'
            },
            {
              title: this.$t('详细地址'),
              scopedSlots: { customRender: 'beforeDetailedAddress' },
            }
          ]
        },
        {
          title: '变更后',
          dataIndex: 'afterAddress',
          children: [
            {
              title: this.$t('收货人姓名'),
              dataIndex: 'afterAddress.realName'
            },
            {
              title: this.$t('手机号'),
              dataIndex: 'afterAddress.mobile'
            },
            {
              title: this.$t('详细地址'),
              scopedSlots: { customRender: 'afterDetailedAddress' },
            }
          ]
        }
      ],
    }
  },
  methods: {
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    handleCancel() {
      this.visible=false
      this.addressLogList=[]
      this.raiseLogList=[]
      this.reset()
    },

    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    reset() {
      this.queryParam.id = undefined
      this.queryParam.pageNum = 1
      this.queryParam.pageSize = 10
    },
    /** 修改按钮操作 */
    handleDetail(id,type) {
      this.queryParam.id=id
      if (type === 1) {
        this.title='地址变更记录'
        changeAddress(this.queryParam).then(res => {
          this.addressLogList = res.data.records
          this.total = res.data.total
          this.visible = true;
        }).finally(() => {
          this.loading = false
        });
      }
    },
  }
}
</script>
